import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { Manifesto } from "@/components/Manifesto";
import { Pricing } from "@/components/Pricing";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => lenisRef.current?.scrollTo(`#${id}`, { offset: -70 }), 400);
    }
  }, []);

  const scrollTo = (id) => lenisRef.current?.scrollTo(`#${id}`, { offset: -70 });

  return (
    <div data-testid="landing-page" className="relative">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <EditorialMarquee />
        <Gallery />
        <Manifesto />
        <Pricing onNavigate={scrollTo} />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
